import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './_services';
import { User } from './_models';

@Component({
    selector: 'orix-subs-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css'],
   
  })
export class AppComponent {
    user: User;
    
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {
        this.authenticationService.user.subscribe(x => this.user = x);
    }

    logout() {
        this.authenticationService.logout();
    }
    getData() {
        alert("aasfaf");
        this.router.navigate(['/my-order']);
    }
}